import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedNumber } from "react-intl";

function Rating({ rating }) {
  if (!rating) return null;

  return (
    <div>
      <p>
        <FormattedNumber
          value={rating}
          intlStyle="decimal"
          minimumFractionDigits="1"
          maximumFractionDigits="1"
        />
      </p>
      <p>
        <span className="header">
          <FormattedMessage id="WA.TechSkill.Iplayme2Rating" />
        </span>
      </p>
    </div>
  );
}

Rating.propTypes = {
  rating: PropTypes.number,
};

export default Rating;
